import React from 'react'
import FinalSubmitTask from './FinalSubmit'

const AdminDashboard = () => {
  return (
    <>
      <FinalSubmitTask />
    </>
  )
}

export default AdminDashboard
